module.exports = "<div class=q-text-center> <span class=\"products-tab-available-units q-pill q-pill-table {%- pillClass %} \" name=\"\"> <strong>{%- unit %} {%- measure %}</strong> <input type=hidden class=products-tab-available-qty value=\"{%- unit %}\"/> </span> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/pages/order/html/unitPill.html
// module id = 300
// module chunks = 1